import React from 'react';
import useLastPerformance from './hooks/useLastPerformance';
import './LastPerformance.css';
import LastPerformanceValue from './LastPerformanceValue';
import WorkingMaxValue from './WorkingMaxValue';

const LastPerformance = props => {
    const {
        athleteId,
        workoutSetExercise,
        date,
        applyPrescription,
        isSubscription
    } = props;

    const {
        isSupported,
        lastPerformanceValue,
        lastPerformanceSavedWorkoutSetExercise,
        isLift,
        workingMaxValue,
        workingMaxUnits,
        reloadLastPerformance
    } = useLastPerformance(athleteId, workoutSetExercise, date);

    if (!isSupported) {
        return null;
    }

    return (
        <div className="lastPerformanceContainer">
            <LastPerformanceValue
                value={lastPerformanceValue}
                savedWorkoutSetExercise={lastPerformanceSavedWorkoutSetExercise}
                applyPrescription={applyPrescription}
                isSubscription={isSubscription}
            />
            <WorkingMaxValue
                userId={athleteId}
                exerciseTitle={workoutSetExercise.title}
                value={workingMaxValue}
                units={workingMaxUnits}
                isLift={isLift}
                exerciseId={workoutSetExercise.exercise_id}
                reload={reloadLastPerformance}
            />
        </div>
    );
};
export default LastPerformance;
